import { io } from 'socket.io-client'

let socketInstance = null
const statusListeners = new Set()

const TOKEN_KEY = 'authToken'

const getAuthToken = () => {
  const fromLocal = localStorage.getItem(TOKEN_KEY)
  if (fromLocal && String(fromLocal).trim()) return String(fromLocal)

  const fromSession = sessionStorage.getItem(TOKEN_KEY)
  if (fromSession && String(fromSession).trim()) return String(fromSession)

  return null
}

const resolveSocketUrl = () => {
  const apiBase = process.env.REACT_APP_API_BASE_URL
  const socketUrl = process.env.REACT_APP_SOCKET_URL

  const base = socketUrl || apiBase || 'http://localhost:5000'
  return base.replace(/\/api\/v1\/?$/, '')
}

const emitStatus = (connected) => {
  statusListeners.forEach((listener) => listener(Boolean(connected)))
}

const bindLifecycleEvents = (socket) => {
  socket.on('connect', () => emitStatus(true))
  socket.on('disconnect', () => emitStatus(false))
  socket.on('connect_error', (err) => {
    emitStatus(false)
    // Mantener log mínimo. No tokens.
    console.warn('[socket] connect_error:', err?.message)
  })
}

/**
 * Connect socket ONLY if auth token exists.
 * This is the single source of truth to prevent pre-login connections.
 */
export const connectSocket = () => {
  const token = getAuthToken()

  // HARD GATE: no token => ensure disconnected and do not connect.
  if (!token) {
    if (socketInstance?.connected) {
      socketInstance.disconnect()
    }
    emitStatus(false)
    return null
  }

  const socketUrl = resolveSocketUrl()

  if (!socketInstance) {
    socketInstance = io(socketUrl, {
      autoConnect: false,
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionAttempts: 8,
      reconnectionDelay: 1000,
      withCredentials: true,
      auth: { token: `Bearer ${token}` },
    })
    bindLifecycleEvents(socketInstance)
  } else {
    socketInstance.auth = { token: `Bearer ${token}` }
  }

  if (!socketInstance.connected) {
    socketInstance.connect()
  }

  return socketInstance
}

export const disconnectSocket = () => {
  if (socketInstance) {
    socketInstance.disconnect()
  }
  emitStatus(false)
}

export const getSocket = () => socketInstance

export const onSocketStatusChange = (listener) => {
  statusListeners.add(listener)
  listener(Boolean(socketInstance?.connected))
  return () => statusListeners.delete(listener)
}

/**
 * Optional: call this on logout to fully reset instance
 * to avoid any accidental reuse.
 */
export const resetSocket = () => {
  if (socketInstance) {
    socketInstance.removeAllListeners()
    socketInstance.disconnect()
    socketInstance = null
  }
  emitStatus(false)
}